
import React from "react";
import ProductPageTemplate from "@/components/ProductPageTemplate";
import { LineChart, Users, Target, Award } from "lucide-react";

const ManagerAnalytics = () => {
  const benefits = [
    {
      title: "Empower Data-Driven Leadership",
      description: "Give managers the insights they need to make informed decisions about their team's engagement, recognition, and development.",
      icon: <LineChart className="h-8 w-8" />
    },
    {
      title: "Identify Team Strengths & Opportunities",
      description: "Help managers understand where their teams excel and where targeted interventions could improve performance or engagement.",
      icon: <Target className="h-8 w-8" />
    },
    {
      title: "Improve Team Connection",
      description: "Provide visibility into team dynamics, collaboration patterns, and recognition behaviors to strengthen team cohesion.",
      icon: <Users className="h-8 w-8" />
    },
    {
      title: "Recognize Effective Management",
      description: "Identify managers whose teams show high engagement and recognition metrics, allowing for celebration and best practice sharing.",
      icon: <Award className="h-8 w-8" />
    }
  ];

  const howItWorks = [
    {
      title: "Access Team-Specific Dashboards",
      description: "Managers can view customized dashboards showing their team's metrics on recognition, engagement, feedback, and performance compared to organizational benchmarks.",
      image: "/lovable-uploads/bc45aff0-bfb1-4e56-a1d9-5c102edb829a.png"
    },
    {
      title: "Receive Actionable Recommendations",
      description: "AI-powered insights suggest specific actions managers can take to improve team dynamics, increase engagement, and enhance performance based on their unique data patterns.",
      image: "/lovable-uploads/a52d8591-9cf7-44a6-be3e-89ff2d22b9f5.png"
    },
    {
      title: "Track Improvement Over Time",
      description: "Managers can monitor how their interventions impact team metrics over time, helping them understand what approaches are most effective for their specific team.",
      image: "/lovable-uploads/509f3d93-4acd-44aa-b232-0ddf2993d259.png"
    }
  ];

  return (
    <ProductPageTemplate
      title="Manager Analytics - Team Performance Insights"
      description="Assembly's Manager Analytics gives team leaders essential insights on engagement, recognition, feedback, and performance to drive data-backed leadership decisions."
      keywords="manager analytics, team performance metrics, leadership dashboard, team engagement data, recognition analytics, people manager tools"
      heroTitle="Give Managers the Insights They Need to Lead Effectively"
      heroDescription="Assembly's Manager Analytics provides team leaders with actionable data about their team's engagement, recognition patterns, and performance—empowering more informed leadership decisions."
      featureDescription="Manager Analytics is Assembly's dashboard solution designed specifically for team leaders. It provides managers with focused insights about their team's engagement, recognition patterns, feedback trends, and performance indicators. By democratizing access to people data and pairing it with actionable recommendations, Manager Analytics helps transform everyday leaders into data-informed managers who can make better decisions about their team's experience and development."
      benefits={benefits}
      howItWorks={howItWorks}
      ctaText="Ready to empower your managers with actionable insights?"
      ctaButtonText="See Manager Analytics in Action"
      mainImage="/lovable-uploads/42f595b0-c093-4a8f-b25a-190b9e5ea2bd.png"
    />
  );
};

export default ManagerAnalytics;
